import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Button from 'aria-viewer/tour/components/buttons/button'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'
import colors from 'aria-viewer/tour/constants/style/colors'
import YVTextField from 'aria-viewer/tour/components/fields/yvTextfield'
import { openModal, closeModal } from '../modalActions'
import ModalTypes from '../constants/ModalTypes'
import ReCAPTCHA from 'react-google-recaptcha'
import { getEnv } from 'aria-viewer/utils/environment'

class FormModal extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            fields: {},
            textAreaFocus: false,
            captchaToken: undefined,
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleTextAreaFocus = this.handleTextAreaFocus.bind(this)
        this.handleTextAreaBlur = this.handleTextAreaBlur.bind(this)
        this.submitAction = this.submitAction.bind(this)
        this.handleOnSubmitButtonClick = this.handleOnSubmitButtonClick.bind(this)
    }
    submitAction() {
        const { url } = this.props.content
        this.props.submitAction({
            url,
            fields: this.state.fields,
        })
    }
    addCloseButton() {
        const { closeModal } = this.props
        return (
            <CloseButton
                onClick={closeModal}
                style={{
                    position: 'absolute',
                    top: '0.25em',
                    right: '0.25em',
                    width: '1.6em',
                    height: '1.6em',
                    borderRadius: '50%',
                    background: styleguide.colors.yellow,
                }}
                svgStyle={{
                    width: '50%',
                    height: '50%',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            />
        )
    }
    addTitle(title, desktop) {
        if (title) {
            {
                return (
                    <div
                        style={{
                            marginBottom: 30,
                        }}
                    >
                        <label style={desktop ? styleguide.modals.desktopTitle : styleguide.modals.title}>
                            {title}
                        </label>
                    </div>
                )
            }
        }
    }
    addSubTitle(subtitle, desktop) {
        if (subtitle) {
            {
                return (
                    <label style={desktop ? styleguide.modals.desktopSubTitle : styleguide.modals.subtitle}>
                        {subtitle}
                    </label>
                )
            }
        }
    }
    init(props) {
        const { fields } = props.content
        const newFields = fields.reduce((newFields, item) => {
            return {
                ...newFields,
                [item.id]: Object.assign({}, { value: '' }, item),
            }
        }, {})
        this.setState({ fields: newFields })
    }
    componentWillMount() {
        this.init(this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.init(nextProps)
    }
    addFields(fields, desktop) {
        {
            let textFieldStyle
            return Object.keys(fields).map((key, index) => {
                const item = fields[key]

                textFieldStyle = null
                switch (item.type) {
                    case 'text':
                        textFieldStyle = desktop
                            ? styleguide.inputfields.desktopTextField
                            : styleguide.inputfields.textField
                        return (
                            <YVTextField
                                key={index}
                                onChange={this.handleChange}
                                item={this.state.fields[item.id]}
                                {...textFieldStyle}
                            />
                        )
                    case 'textarea':
                        textFieldStyle = desktop
                            ? item.textAreaFocus
                                ? Object.assign({}, styleguide.inputfields.desktopTextArea, {
                                      textareaStyle: {
                                          border: `2px solid ${colors.yellow}`,
                                          borderRadius: '4px',
                                          fontSize: '14px',
                                          padding: '10px 11px',
                                      },
                                  })
                                : styleguide.inputfields.desktopTextArea
                            : styleguide.inputfields.textArea
                        return (
                            <YVTextField
                                key={index}
                                onChange={this.handleChange}
                                onFocus={this.handleTextAreaFocus}
                                onBlur={this.handleTextAreaBlur}
                                item={this.state.fields[item.id]}
                                {...textFieldStyle}
                            />
                        )
                }
            })
        }
    }
    updateFieldValue(id, key, value) {
        const { fields } = this.state
        fields[id] = Object.assign({}, fields[id], {
            [key]: value,
        })
        this.setState(fields)
    }
    handleChange(item, event) {
        this.updateFieldValue(item.id, 'value', event.target.value)
    }
    handleTextAreaFocus(item, event) {
        this.updateFieldValue(item.id, 'textAreaFocus', true)
    }
    handleTextAreaBlur(item, event) {
        this.updateFieldValue(item.id, 'textAreaFocus', false)
    }
    handleOnCaptchaChange = value => {
        this.setState({
            captchaToken: value,
        })
    }
    addSubmitButton(submit, desktop) {
        if (submit) {
            const submitButtonStyle = desktop ? styleguide.modals.submitDesktopButton : styleguide.modals.submitButton
            return (
                <Button onClick={this.handleOnSubmitButtonClick} {...submitButtonStyle}>
                    {submit.label}
                </Button>
            )
        }
    }
    addCaptcha({ enable, size = 'normal' }) {
        if (enable) {
            return (
                <ReCAPTCHA size={size} sitekey={getEnv('REACT_APP_RECAPTCHA')} onChange={this.handleOnCaptchaChange} />
            )
        }
    }
    handleOnSubmitButtonClick(e) {
        const {
            submitAction,
            content: { url },
            openModal,
            closeModal,
        } = this.props
        const { fields, captchaToken } = this.state
        if (submitAction) {
            const formFields = Object.keys(fields).reduce((formFields, key) => {
                const item = fields[key]
                return {
                    ...formFields,
                    [item.id]: item.value,
                }
            }, {})
            submitAction({ url, fields: { ...formFields, token: captchaToken } }).then(result => {
                const { success, errors } = result
                if (success) {
                    closeModal()
                    openModal(ModalTypes.ALERT, {
                        body: 'Your email was successfully sent!',
                    })
                } else {
                    // if the submission was unsuccessful,
                    // show what fields had an error
                    const { fields } = this.state
                    const newFields = Object.keys(fields).reduce((newFields, key) => {
                        const item = fields[key]
                        return {
                            ...newFields,
                            [item.id]: Object.assign({}, item, { error: errors[item.id] || null }),
                        }
                    }, {})

                    openModal(ModalTypes.ALERT, {
                        body:
                            'There was an error submitting your form. Please contact qa@youvisit.com for assistance with this problem.',
                    })

                    this.setState({ fields: newFields })
                }
            })
        }
    }
    render() {
        const { content, desktop } = this.props
        return (
            <div className="formModal">
                {desktop ? null : this.addCloseButton()}
                {this.addTitle(content.title, desktop)}
                {this.addSubTitle(content.subtitle, desktop)}
                {this.addFields(this.state.fields, desktop)}
                {content.captcha && this.addCaptcha(content.captcha)}
                {this.addSubmitButton(content.submit, desktop)}
            </div>
        )
    }
}

export default connect(
    null,
    {
        openModal,
        closeModal,
    }
)(FormModal)
